import doc               from '@widesk-core/decorators/doc';
import model             from '@widesk-core/decorators/model';
import AuditServiceModel from '@/models/AuditServiceModel';
import { computed }      from 'mobx';
import dayjs             from 'dayjs';

type UrnObject = Record<'partition' | 'service' | 'resource' | 'identifier', string>;

@model.urnResource('event')
@doc.path('/events/{?id}')
export default class EventModel extends AuditServiceModel {
	private declare _tsFilters: {
		'actor.urn.identifier': string;
		'subject.metadata.account_urn': string;
		'subject.metadata.subscription_urn': string;
		'subject.metadata.account_subscription_urn': string;
		'subject.metadata.functionality_urn': string;
		'kind': string;
		'timestamp[gte]': string | Date | Dayjs;
		'timestamp[lte]': string | Date | Dayjs;
		'subject.urn.service[eq]': string;
		'subject.urn.resource[eq]': string;
	};

	private declare _tsSorts: {
		'timestamp': string;
	};

	@doc.string declare kind: string;
	@doc.string declare parentUuid: string;
	@doc.string declare timestamp: string;
	@doc.string declare type: string;
	@doc.string declare uuid: string;

	@computed
	public get actor() {
		return this.get('actor', {});
	}

	@computed
	public get subject() {
		return this.get('subject', {});
	}

	@computed
	public get subjectMetadata() {
		return this.get('subject.metadata', {});
	}

	@computed
	public get parentUrn(): Urn | undefined {
		return this.get('subject.metadata.parent_urn');
	}

	@computed
	public get userUrn() {
		const actorUrn = this.actor.urn as UrnObject | undefined;
		return actorUrn
			? `${actorUrn.partition}:${actorUrn.service}:${actorUrn.resource}:${actorUrn.identifier}` as Urn
			: undefined;
	}

	@computed
	public get subjectUrnObject() {
		return this.subject.urn as UrnObject | undefined;
	}

	@computed
	public get subjectUrn(): Urn | undefined {
		const urnObj = this.subjectUrnObject;
		return urnObj
			? `${urnObj.partition}:${urnObj.service}:${urnObj.resource}:${urnObj.identifier}` as Urn
			: undefined;
	}

	@computed
	public get date() {
		return dayjs(this.timestamp);
	}

	@computed
	public get kindLabel() {
		switch (this.kind) {
			case 'created':
				return 'Ajout';
			case 'updated':
				return 'Modification';
			case 'deleted':
				return 'Suppression';
			case 'email_delivered':
				return 'Email';
			default:
				return this.kind;
		}
	}

	@computed
	public get kindColor() {
		switch (this.kind) {
			case 'created':
				return 'success';
			case 'updated':
				return 'warning';
			case 'deleted':
				return 'error';
			case 'email_delivered':
				return 'processing';
			default:
				return 'default';
		}
	}

	@computed
	public get action() {
		switch (this.kind) {
			case 'created':
				return 'a créé';
			case 'updated':
				return 'a modifié';
			case 'deleted':
				return 'a supprimé';
			case 'email_delivered':
				return `a délivré un email`;
			default:
				return this.kind;
		}
	}
}